module.exports = __webpack_public_path__ + "static/media/icon-bud@2x.018567a8.svg";